import React, { useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  FloatingLabel,
} from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../Config";

const Collaborate = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    message: "",
    agree: false,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // Handle form field changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!formData.mobile_number) {
      newErrors.mobile_number = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Mobile number must be 10 digits.";
    }

    if (!formData.message) newErrors.message = "Message is required.";
    if (!formData.agree) newErrors.agree = "You must agree to the terms.";
    return newErrors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);
    setErrorMessage("");
    setSuccessMessage("");

    if (Object.keys(validationErrors).length === 0) {
      // Form is valid, proceed with submission
      console.log("Form submitted successfully!", formData);

      try {
        var url = API_URL + "inquiry/contactus";
        const response = await axios.post(url, formData);
        setSuccessMessage(response.data.message);
        setFormData({
          name: "",
          email: "",
          mobile_number: "",
          message: "",
        });
      } catch (error) {
        // Handle any errors
        if (error.response) {
          // The server responded with an error
          console.error("Error response:", error.response.data);

          if (error.response.data.detail === "Username already taken") {
            setErrors(
              "Email is already registered with us.! Please click forgot password."
            );
          } else {
            setErrors("An error occurred. Please try again.");
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error("Error request:", error.request);
          setErrors("No response from the server. Please try again later.");
        } else {
          // Something else caused the error
          console.error("Error:", error.message);
          setErrors("An unknown error occurred. Please try again.");
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div>
      <Container className="collaborate-section rounded ">
        <p className="text-center">
          <span className="highlight-text text-center mb-4">
            Collaborate With Us
          </span>
        </p>
        {successMessage && <Alert variant="success">{successMessage}</Alert>}
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        <Row className="justify-content-center my-3">
          <Col xs={12} md={8}>
            <Form onSubmit={handleSubmit}>
              <br />
              <Form.Group className="mb-3" controlId="name">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Email address"
                  className="mb-3"
                >
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
              <Form.Group className="mb-3" controlId="mobile_number">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Mobile Number"
                  className="mb-3"
                >
                  <Form.Control
                    type="mobile"
                    placeholder="Mobile Number"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    isInvalid={!!errors.mobile_number}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.mobile_number}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
              <Form.Group className="mb-3" controlId="message">
                <FloatingLabel controlId="floatingInput" label="Message">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    style={{ height: "100px" }}
                    placeholder="Your message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    isInvalid={!!errors.message}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.message}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
              <Row className="justify-content-center my-3">
                <Col xs={12} md={5} className="text-center">
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="I agree to the terms and conditions"
                      name="agree"
                      checked={formData.agree}
                      onChange={handleChange}
                      isInvalid={!!errors.agree}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.agree}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <br />
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Collaborate;
